import api from 'libs/api'
import { ERROR, SUCCESS, PROCESSING } from 'constants/forgot-password'

const onError = payload => {
  return {
    type: ERROR,
    loading: false,
    payload,
  }
}

export const forgotPassword = email => dispatch => {
  dispatch({
    type: PROCESSING,
  })

  return api
    .postForgotPassword(email)
    .then(response => response.json())
    .then(reponse => {
      if (reponse.status === 200) {
        dispatch({
          type: SUCCESS,
          message: 'Success',
        })
      } else {
        dispatch(onError(reponse.errors))
      }
    })
}
